<template>
  <vue-modal no-close ref="modal">
    <template v-slot:header>
      <div class="p-3 bg-dark fw-600 text-white text-center">
        Responsible Gambling Check
      </div>
    </template>
    <template v-slot:default>
      <div v-if="loading">
        <div class="loading-shade"></div>
        <pre-loader></pre-loader>
      </div>

      <!-- QUESTION -->
      <template v-if="!showResult">
        <div class="container-survey">
          <div class="text">We tried recently to contact you about your level of spend and/or activity with us, without success. We must ask for your brief responses to these short questions. Once you have updated this, the site will be fully available to you, and we will not bother you going forward.  Alternatively, you can also give us a call on 01344 873334 to have a customer interaction phone call.</div>


          <!-- Questions -->
          <div v-for="(question, idx) in questions" :key="idx" class="survey-item">
            <div class="lbl-required">{{ idx + 1}}. {{ question.text }}</div>
            <vue-textarea
              :show-characters-left="false"
              :error="answerModel[idx]?.errorMessage"
              :name="`answer${idx}`"
              type="text"
              show-words-count
              :min-words="question.minWords"
              v-model="answer[idx]"
              @touched="() => {touched[idx] = true}"
            />
          </div>
          <div class="text">Your answers will help us protect you and will be treated confidentially while ensuring your account is updated with us.</div>
        </div>
        <vue-button 
          type="button"
          @click="submitForm"
          :disabled="!isAllAnswered"
          :cls="isAllAnswered ? 'main': 'disable'">Submit & Continue</vue-button>
      </template>

      <!-- RESULT -->
      <template v-else>
        <div class="container-survey">
          <div class="result">
      
            Thank you for your time with this. If you ever need to talk about your activity, we're always available for a chat on 01344 873334 or email us at <a class="geoff-link-accent" href="mailto:support@geoffbanks.bet">support@geoffbanks.bet</a>. Additionally, visit our <a class="geoff-link-accent" href="javascript://" @click="goToResponsibleGambling" >Responsible Gambling page</a> for tools and advice.
          </div>
          <vue-button 
            type="button"
            @click="close"
            cls="main">OK</vue-button>
        </div>
      </template>
    </template>
  </vue-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { GetWordsCount } from "@/http/utils"
import PreLoader from "@/components/UI/PreLoader";
import VueModal from "@/components/UI/VueModal";
import VueButton from "@/components/UI/VueButton";
import VueTextarea from "@/components/UI/VueTextarea";

export default {
  name: "ResponsibleGamblingCheckModal",
  components: {
    PreLoader,
    VueModal,
    VueButton,
    VueTextarea
  },
  data: () => {
    return {
      loading: false,
      showResult: false,
      questions: [
        { 
          text: 'What, in your own words, is your primary source of income? (If employed or business owner, please confirm the company/business name.)',
          minWords: 10
        },
            { 
          text: 'What is the maximum amount you estimate depositing with us per month? (If possible, please also give an estimate of what percentage of your income this represents.)',
          minWords: 1
        },
            { 
          text: 'Please describe any outstanding debts or financial commitments you have and how they might influence your gambling activity (If applicable).',
          minWords: 1
        },
            { 
          text: 'Are you completely comfortable with your level of spend with us at the current time and would you require any support in this regards? ',
          minWords: 6
        },
            { 
          text: 'Can you share any experiences where gambling has felt difficult to control or has affected your well-being? Please provide details if applicable.',
          minWords: 6 
        },
      ],
      answer: [],
      touched:[false, false, false, false, false],
    }
  },
  computed: {
    ...mapGetters(['USER']),
    userName() {
      return `${this.USER?.first_name} ${this.USER?.last_name}`
    },
    isAllAnswered() {
      return this.answerModel
        .every(a => {
        return !!a?.text && GetWordsCount(a?.text) >= a.minWords
      })
    },

    answerModel() {

      return this.questions.map((el, idx) => {
        const ans = this.answer[idx]
        let error = ''
        if (!ans?.length || GetWordsCount(ans) < el.minWords) {
          error = ' ' //'15 words min'
        }
        return {
          text: ans,
          minWords: el.minWords,
          touched: this.touched[idx],
          ...error && this.touched[idx] && {isError: true},
          ...error && this.touched[idx] && {errorMessage: error}

        }
      })
    }
  
    
  },
  watch: {
    'USER.displaySaferGamblingModal'() {
      this.initPopupState()
    }
  },
  mounted() {
    this.initPopupState()
  },
  methods:{
    initPopupState() {
      if (this.USER?.displaySaferGamblingModal) {
        this.$refs.modal.open()
      }
    },
    submitForm() {
      this.loading = true;
      const model = {
        incomePrimarySourceResponse: this.answerModel[0]?.text,
        maxMonthlyDepositAmountResponse: this.answerModel[1]?.text,
        outstandingDebtsAndCommitments: this.answerModel[2]?.text,
        comfortableWithSpendResponse: this.answerModel[3]?.text,
        gamblingControlExperienceResponse: this.answerModel[4]?.text,
      }
      
      this.API.postResponsibleGamblingCheck(model)
        .then(resp => {
          if (resp.isFormSent) {
            this.loading = false;
            this.showResult = true
          }
          else {
            this.$toast.error('Something went wrong. Please try again later')
            this.loading = false;
          }
          
        })
        .catch(er => {
          this.$toast.error('Something went wrong. Please try again later')
          console.log('postResponsibleGamblingCheck ERROR', er)
          this.loading = false;
        })
        .finally(() => {
          //reload user info
          this.$store.dispatch('GET_USER_INFO')
        })
    },
    close() {
      this.$refs.modal.close()
    },
    goToDeposit() {
      this.$router.push({name: 'updateDepositLimit'})
      this.$refs.modal.close()
    },
    goToResponsibleGambling() {
      this.$router.push( {name:'info', params: { infoType: 'ResponsibleGambling' }})
      this.$refs.modal.close()
    }

  }
}
</script>

<style scoped lang="scss">
.content{
  max-width: 400px;
}

.container-survey {
  margin: 1rem 0;
  max-width: 60vw;
  @media only screen and (max-width: 1024px){
    max-width: unset;
  }

  .text {
    margin-bottom: 1.5rem;
    font-weight: 700;
  }


  .survey-item {
    // display: grid;
    // grid-template-columns: 80% 1fr 1fr;
    // align-items: center;
    // text-align: center;
    margin-bottom: 1rem;

    >div:first-child {
      text-align: left;
    }

    &.title {
      text-transform: uppercase;
    }
  }

  .result {
    margin-bottom: 1rem;
  }
}
</style>